import { Chart } from '~/shared/types/chart'
import { ChartMaker } from '../../../utils/ChartMaker'
import { ChartEditContext, useInitChartEditState } from './ChartEditContext'
import ChartEditUi from './ChartEditUi'

const chartMaker = new ChartMaker

export default function ChartEdit({ chart }: { chart: Chart }) {
  const chartEditState = useInitChartEditState({ chart })
  return (
    <ChartEditContext.Provider value={chartEditState}>
      <ChartEditUi />
    </ChartEditContext.Provider>
  )
}
